// extracted by mini-css-extract-plugin
export default {"label":"Label_label__CktK-","inline":"Label_inline__2DW6d","normalCursor":"Label_normalCursor__ASq8W"};